import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/var/www/dental/frontend/node_modules/sonner/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/var/www/dental/frontend/src/contexts/AuthContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FocusModeProvider"] */ "/var/www/dental/frontend/src/contexts/FocusModeContext.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/dental/frontend/src/styles/tailwind.css");
